import React, { PropTypes } from 'react';
import validate from '../../util/inputValidation.js';
import _ from 'lodash';
import { appContext } from '../../util/decorators';

@appContext
export default class Checkbox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: props.prefilled || false,
      inputErrors: [],
    };
    this.t = context.app.t;
  }

  handleChange(evt) {
    if (!evt.target) return;
    const value = evt.target.checked;
    const { onChange, name } = this.props;
    let inputErrors = [];

    inputErrors = validate(name, value);

    this.setState({ value, inputErrors }, onChange(value));
  }

  render() {
    const { t } = this;
    const { value, inputErrors } = this.state;
    const { label, name, required } = this.props;

    return (
      <div className={this.props.className}>
        <label className="margin-bottom">
          <input
            name={name}
            type="checkbox"
            onChange={evt => this.handleChange(evt)}
            checked={value}
          />
          {' '}
          {label}
        </label>
        {_.map(inputErrors, (inputError, idx) => (
          <div className="input-error" key={idx}>{t(inputError)}</div>
        ))}
        {required &&
          !inputErrors.length &&
          <div className="input-error">
            {t('Validation.terms_and_conditions')}
          </div>}
      </div>
    );
  }
}

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  prefilled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/Forms/Checkbox.jsx